import { render, staticRenderFns } from "./institutionAdd.vue?vue&type=template&id=da0f3e14&scoped=true&"
import script from "./institutionAdd.vue?vue&type=script&lang=js&"
export * from "./institutionAdd.vue?vue&type=script&lang=js&"
import style0 from "./institutionAdd.vue?vue&type=style&index=0&id=da0f3e14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0f3e14",
  null
  
)

export default component.exports